import { Select } from "@ttc3k/trekker";
import { ComponentProps } from "react";
import { useController, useFormContext } from "react-hook-form";

export type ControlledSelectRootProps = ComponentProps<typeof Select.Root> & {
  name: string;
};

export const ControlledSelectRoot = ({
  name,
  hint,
  ...rest
}: ControlledSelectRootProps) => {
  const { register, control } = useFormContext();
  const { fieldState } = useController({ name, control });

  const props = {
    ...rest,
    ...register(name),
    hint: fieldState.error?.message ?? hint,
    ...(fieldState.error
      ? { invalid: true, "data-invalid": true, "aria-invalid": true }
      : { invalid: false }),
  };

  return <Select.Root {...props} />;
};
